module.exports = __webpack_public_path__ + "static/img/logo.27092a96.svg";